<script>
export default {
    name: 'TermsOfService',
    computed: {
        tos() {
            return this.$appConfig('TOS', false)
        },
        privacyPolicy() {
            return this.$appConfig('PRIVACY_POLICY', false)
        },
    },
    methods: {},
}
</script>

<template>
    <div>
        <div>
            <h1><strong>Términos de Servicio &amp; Política de Privacidad</strong></h1>

            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Fecha de Vigencia: 28 de julio de 2025</p>

            <h2><strong>1. Visión General</strong></h2>
            <p>Estos Términos de Servicio y Política de Privacidad (“Política”) rigen las comunicaciones iniciadas a través de Shift Arcade Ventures LLC (“Shift Arcade Ventures,” “nosotros,” “nuestro,” o “nos”), incluyendo SMS, correo electrónico y otros mensajes electrónicos enviados en conexión con:</p>
            <ul>
                <li>Comunicaciones generales de Shift Arcade</li>
                <li>Consultas de franquicia y actualizaciones relacionadas con franquicias</li>
                <li>Compromiso del cliente a nivel de pre-ubicación o red</li>
            </ul>
            <p>
                Shift Arcade Ventures LLC es el franquiciante y propietario de la marca Shift Arcade. Las ubicaciones individuales de Shift Arcade son negocios independientes y operados de manera independiente. Cada ubicación mantiene sus propios Términos de Servicio y Política de Privacidad que rigen las reservas, experiencias en el sitio, pagos,
                exenciones y comunicaciones específicas de la ubicación.
            </p>
            <p>Los términos específicos de la ubicación se pueden encontrar en los sitios web de las respectivas ubicaciones (por ejemplo:</p>
            <p>
                <a href="https://sanramon.shiftarcade.com/privacy-terms"> https://sanramon.shiftarcade.com/privacy-terms </a>
            </p>

            <h2><strong>2. Alcance de Esta Política</strong></h2>
            <p>Esta Política se aplica cuando un individuo:</p>
            <ul>
                <li>Envía un formulario en un sitio web de Shift Arcade o Shift Arcade Ventures</li>
                <li>Opta por recibir comunicaciones por SMS o correo electrónico</li>
                <li>Solicita información sobre ubicaciones de Shift Arcade u oportunidades de franquicia</li>
                <li>Se inscribe para recibir actualizaciones antes de seleccionar una ubicación específica</li>
            </ul>
            <p>Una vez que un cliente se compromete directamente con una ubicación específica de Shift Arcade (por ejemplo, haciendo una reserva), los Términos de Servicio y la Política de Privacidad de esa ubicación regirán la relación para esos servicios.</p>

            <h2><strong>3. Comunicaciones &amp; Programas de Mensajería</strong></h2>

            <h3><strong>3.1 Propósito de las Comunicaciones</strong></h3>
            <p>Al optar por participar, los individuos pueden recibir mensajes informativos y relacionados con el servicio, incluyendo pero no limitado a:</p>
            <ul>
                <li>Respuestas a consultas</li>
                <li>Actualizaciones relacionadas con Shift Arcade o la red de Shift Arcade</li>
                <li>Seguimientos de consultas de franquicia (para posibles franquiciados)</li>
                <li>Compromiso general del cliente o actualizaciones informativas</li>
            </ul>

            <p><strong>Distinción importante (para claridad, no separación):</strong></p>
            <ul>
                <li>Las consultas de franquicia reciben comunicaciones relacionadas solo con el proceso de descubrimiento de franquicias.</li>
                <li>Las comunicaciones relacionadas con el cliente se limitan al compromiso general, no específico de la ubicación, a menos y hasta que el cliente se comprometa con una ubicación específica.</li>
            </ul>
            <p>Los datos recopilados para consultas de franquicia son mantenidos únicamente por Shift Arcade Ventures LLC y no se comparten con ubicaciones de franquicia individuales.</p>

            <h3><strong>3.2 Consentimiento para SMS &amp; Cancelación</strong></h3>
            <p>Al optar por recibir comunicaciones por SMS, aceptas recibir mensajes de texto de Shift Arcade Ventures LLC.</p>
            <ul>
                <li>La frecuencia de los mensajes varía según el compromiso</li>
                <li>Pueden aplicarse tarifas de mensaje y datos</li>
                <li>Los operadores no son responsables de mensajes retrasados o no entregados</li>
            </ul>
            <p>Puedes cancelar los mensajes SMS en cualquier momento respondiendo <strong>STOP</strong>.</p>
            <p>Puedes solicitar ayuda respondiendo <strong>HELP</strong>.</p>
            <p>Después de cancelar, recibirás un mensaje de confirmación y no se enviarán más mensajes a menos que te vuelvas a suscribir.</p>

            <h2><strong>4. Información que Recopilamos</strong></h2>
            <p>Podemos recopilar la siguiente información cuando interactúas con nosotros:</p>
            <ul>
                <li>Nombre</li>
                <li>Número de teléfono</li>
                <li>Dirección de correo electrónico</li>
                <li>Información proporcionada voluntariamente a través de formularios o mensajes</li>
            </ul>
            <p>Esta información se recopila solo para fines comerciales legítimos relacionados con la comunicación, manejo de consultas y compromiso con el cliente o franquicia.</p>

            <h2><strong>5. Cómo Usamos la Información</strong></h2>
            <p>La información recopilada puede ser utilizada para:</p>
            <ul>
                <li>Responder a consultas</li>
                <li>Proporcionar la información solicitada</li>
                <li>Comunicar actualizaciones relacionadas con tu interés expresado</li>
                <li>Mejorar los procesos de comunicación y soporte</li>
                <li>Mantener el cumplimiento con los requisitos legales y de mensajería</li>
            </ul>
            <p>No utilizamos esta información para fines de marketing no relacionados sin el consentimiento adecuado.</p>

            <h2><strong>6. Compartición de Datos &amp; Terceros</strong></h2>
            <p>No vendemos ni alquilamos información personal.</p>
            <p>Podemos utilizar proveedores de servicios de confianza (como plataformas de CRM, correo electrónico o SMS) únicamente para apoyar las comunicaciones y operaciones. Estos proveedores están contractualmente obligados a proteger los datos y cumplir con las leyes de privacidad aplicables.</p>
            <p><strong>Los datos de consentimiento y opt-in de mensajería de texto nunca se comparten</strong>, excepto con agregadores y proveedores necesarios para entregar servicios de mensajería.</p>

            <h2><strong>7. Seguridad de los Datos</strong></h2>
            <p>Tomamos medidas administrativas, técnicas y físicas razonables para proteger la información personal. Aunque ningún sistema puede garantizarse como 100% seguro, utilizamos salvaguardas comercialmente razonables para proteger los datos contra el acceso no autorizado o el uso indebido.</p>

            <h2><strong>8. Cumplimiento de las Leyes</strong></h2>
            <p>Cumplimos con las leyes locales, estatales y federales aplicables, incluidas las regulaciones de mensajería móvil y los estándares de la industria (incluidas las pautas de TCPA y CTIA).</p>
            <p>Al participar en nuestras comunicaciones, reconoces y aceptas cumplir con todas las leyes aplicables.</p>

            <h2><strong>9. Cambios a Esta Política</strong></h2>
            <p>Podemos actualizar esta Política de vez en cuando. Las actualizaciones se publicarán en:</p>
            <p>
                <strong>
                    <a href="https://shiftarcade.com/privacy-terms"> https://shiftarcade.com/privacy-terms </a>
                </strong>
            </p>
            <p>La participación continua en las comunicaciones después de las actualizaciones constituye la aceptación de la Política revisada.</p>

            <h2><strong>10. Información de Contacto</strong></h2>
            <p>Para preguntas sobre esta Política o nuestras prácticas de datos, por favor contacta a:</p>
            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Email: <strong>franchise@shiftarcade.com</strong></p>
        </div>
        <hr />
        <h2><strong>Términos de Suscripción del Club Apex</strong></h2>

        <h3><strong>Facturación de Suscripción &amp; Plazo Mínimo</strong></h3>
        <p>El Club Apex es una <strong>suscripción mensual recurrente</strong>. Al inscribirse en el Club Apex, el cliente autoriza a Shift Arcade a cargar automáticamente el método de pago seleccionado <strong>cada mes</strong> a la tarifa de suscripción publicada.</p>
        <p>
            Todas las suscripciones del Club Apex tienen un
            <strong>compromiso mínimo de dos (2) meses</strong>. La suscripción no puede cancelarse durante el plazo inicial de dos meses.
        </p>
        <p>
            Después de que se haya cumplido el plazo mínimo, la suscripción continuará en una
            <strong>base mensual</strong> a menos que el cliente la cancele.
        </p>

        <h3><strong>Renovación &amp; Cancelación</strong></h3>
        <p>Después del plazo mínimo inicial de dos meses, el cliente puede cancelar la suscripción en cualquier momento proporcionando un aviso a través de su cuenta o contactando directamente con la ubicación.</p>
        <p>Las cancelaciones entran en vigor al <strong>final del período de facturación actual</strong>. No se emiten reembolsos parciales por tiempo no utilizado, créditos o beneficios dentro de un período de facturación.</p>
        <p>Para cancelar la Membresía del Club Apex, visita tu panel de control de cuenta.</p>

        <h3><strong>Créditos, Beneficios &amp; Uso</strong></h3>
        <p>Los beneficios de la suscripción, incluidos los créditos mensuales o el acceso con descuento, se emiten <strong>cada ciclo de facturación</strong> y están destinados para su uso durante el período de suscripción activa.</p>
        <p>Créditos o beneficios no utilizados:</p>
        <ul>
            <li>No se convierten en efectivo</li>
            <li>No son transferibles</li>
            <li>Pueden expirar si la suscripción se cancela, dependiendo de los términos específicos del plan del Club Apex</li>
        </ul>
        <p>Los beneficios de la suscripción están sujetos a disponibilidad y pueden variar según la ubicación.</p>

        <h3><strong>No hay Reembolsos por Uso Perdido</strong></h3>
        <p>
            No utilizar los beneficios del Club Apex durante un período de facturación no constituye motivo para un reembolso o crédito. La suscripción proporciona
            <strong>acceso y elegibilidad</strong>, no uso garantizado.
        </p>

        <h3><strong>Cambios en los Términos de Suscripción</strong></h3>
        <p>Shift Arcade se reserva el derecho de modificar los precios, beneficios o términos del Club Apex con un aviso razonable. Cualquier cambio se aplicará de manera prospectiva y se comunicará por correo electrónico, SMS o términos publicados.</p>

        <h3><strong>Reconocimiento</strong></h3>
        <p>Al inscribirse en el Club Apex, el cliente reconoce y acepta que:</p>
        <ul>
            <li>La suscripción se factura <strong>mensualmente</strong></li>
            <li>Se aplica un <strong>plazo mínimo de dos meses</strong></li>
            <li>Los cargos continuarán automáticamente a menos que se cancele después del plazo mínimo</li>
        </ul>
    </div>
</template>
